import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import FAQ from "./pages/FAQ";
import Admin from "./pages/Admin";

function ShellLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            fontFamily: "DM Sans, system-ui, sans-serif",
                        },
                    }}
                />
                <Routes>
                    <Route
                        path="/admin"
                        element={<Admin />}
                        data-testid="admin-route"
                    />
                    <Route
                        path="*"
                        element={
                            <ShellLayout>
                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/services" element={<Services />} />
                                    <Route path="/projects" element={<Projects />} />
                                    <Route path="/about" element={<About />} />
                                    <Route path="/contact" element={<Contact />} />
                                    <Route path="/quote" element={<Quote />} />
                                    <Route path="/faq" element={<FAQ />} />
                                </Routes>
                            </ShellLayout>
                        }
                    />
                </Routes>
            </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
